export default __webpack_public_path__ + "static/pcab-ac1c99b559e90661682a9b80cea15ba6.png";